import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לרצון שיראו",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להסביר.",
      "אני רק שם/ה לב לרצון שיראו אותי.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה להסביר.",
      "אני רק שם/ה לב לרצון שיראו אותי.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני מרגיש/ה שהאחרים לא באמת מכירים אותי?",
      "מה בי לא מקבל מקום שם?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי אני מרגיש/ה שהאחרים לא באמת מכירים אותי?",
      "מה בי לא מקבל מקום שם?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב לרצון שיראו אותי הוא כבר קשר."
    ],
      [
      "לשים לב לרצון שיראו אותי הוא כבר קשר."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה אני לא מראה",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת מה אני משאיר/ה בפנים.",
      "לא כדי לשנות.",
      "רק לראות."
    ],
      [
      "היום אני בודק/ת מה אני משאיר/ה בפנים.",
      "לא כדי לשנות.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מסתיר/ה מאנשים קרובים?",
      "למה אני שומר/ת את זה לעצמי?",
      "מה אני מפחד/ת שיקרה אם יראו?"
    ],
      [
      "מה אני מסתיר/ה מאנשים קרובים?",
      "למה אני שומר/ת את זה לעצמי?",
      "מה אני מפחד/ת שיקרה אם יראו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שמירה לא אומרת שאין בי אמת."
    ],
      [
      "שמירה לא אומרת שאין בי אמת."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב אמת אחת לעצמי.",
      "לכתוב אמת אחת לעצמי."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "רגעים שכן ראו אותי",
    opening: localizedGenderNode(
      [
      "היום אני נזכר/ת ברגעים שכן ראו אותי.",
      "גם אם מעטים.",
      "הם קיימים."
    ],
      [
      "היום אני נזכר/ת ברגעים שכן ראו אותי.",
      "גם אם מעטים.",
      "הם קיימים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הרגשתי שמישהו באמת רואה אותי?",
      "מה היה שונה שם?",
      "מה זה עשה לי בפנים?"
    ],
      [
      "מתי הרגשתי שמישהו באמת רואה אותי?",
      "מה היה שונה שם?",
      "מה זה עשה לי בפנים?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם רגע קטן של ראייה מחמם."
    ],
      [
      "גם רגע קטן של ראייה מחמם."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע כזה.",
      "לזכור רגע כזה."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מה אני מחפש/ת",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת מה אני מחפש/ת בקשר.",
      "לא דרישה.",
      "רק צורך."
    ],
      [
      "היום אני שואל/ת מה אני מחפש/ת בקשר.",
      "לא דרישה.",
      "רק צורך."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הבטן."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הבטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה כדי להרגיש שמכירים אותי?",
      "מה חסר לי שם?",
      "מה הייתי רוצה לבקש בעדינות?"
    ],
      [
      "מה אני בוחר/ת/ה כדי להרגיש שמכירים אותי?",
      "מה חסר לי שם?",
      "מה הייתי רוצה לבקש בעדינות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צורך ברור מרכך את הלב."
    ],
      [
      "צורך ברור מרכך את הלב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב צורך אחד במילה.",
      "לכתוב צורך אחד במילה."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "פחד שמחזיק אותי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לפחד שמחזיק אותי בפנים.",
      "לא להילחם בו.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב לפחד שמחזיק אותי בפנים.",
      "לא להילחם בו.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מפחד/ת שיקרה אם יכירו אותי?",
      "מה אני חושב/ת שיאבד לי?",
      "איך הפחד הזה שומר עליי?"
    ],
      [
      "מה אני מפחד/ת שיקרה אם יכירו אותי?",
      "מה אני חושב/ת שיאבד לי?",
      "איך הפחד הזה שומר עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לפעמים פחד הוא שמירה על לב עדין."
    ],
      [
      "לפעמים פחד הוא שמירה על לב עדין."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "מקום קטן לביטוי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך נותנים מקום קטן לביטוי.",
      "לא הכול.",
      "רק מעט."
    ],
      [
      "היום אני בודק/ת איך נותנים מקום קטן לביטוי.",
      "לא הכול.",
      "רק מעט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגרון."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הגרון."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חלק קטן בי רוצה שיישמע?",
      "איפה אפשר לתת לו מקום בטוח?",
      "מה צעד קטן שאפשר לעשות?"
    ],
      [
      "מה חלק קטן בי רוצה שיישמע?",
      "איפה אפשר לתת לו מקום בטוח?",
      "מה צעד קטן שאפשר לעשות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם מעט ביטוי משנה משהו."
    ],
      [
      "גם מעט ביטוי משנה משהו."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב משפט אחד שאני לא אומר/ת בקול.",
      "לכתוב משפט אחד שאני לא אומר/ת בקול."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "להיות איתי גם בתוך אנשים",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר איתי גם כשיש אנשים.",
      "לא להיעלם.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להישאר איתי גם כשיש אנשים.",
      "לא להיעלם.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הרגליים."
    ],
      [
      "אני עוצר/ת רגע.",
      "אני מרגיש/ה את הרגליים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך נראה להיות איתי בתוך שיחה?",
      "מה מזכיר לי אותי שם?",
      "מה יכול לעזור לי להישאר?"
    ],
      [
      "איך נראה להיות איתי בתוך שיחה?",
      "מה מזכיר לי אותי שם?",
      "מה יכול לעזור לי להישאר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להישאר איתי הוא עוגן."
    ],
      [
      "להישאר איתי הוא עוגן."
    ]
    ),
    action: localizedGenderNode(
      "נגיעה קטנה בלב כשאני עם אנשים.",
      "נגיעה קטנה בלב כשאני עם אנשים."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חיבור קטן אמיתי",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת חיבור קטן שהוא אמיתי.",
      "לא גדול.",
      "רק אמיתי."
    ],
      [
      "היום אני מחפש/ת חיבור קטן שהוא אמיתי.",
      "לא גדול.",
      "רק אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "עם מי אני מרגיש/ה הכי אמיתי/ת?",
      "מה יש שם שמאפשר אמת?",
      "מה צעד קטן יכול להעמיק את זה?"
    ],
      [
      "עם מי אני מרגיש/ה הכי אמיתי/ת?",
      "מה יש שם שמאפשר אמת?",
      "מה צעד קטן יכול להעמיק את זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אמת קטנה יכולה לשנות קירבה."
    ],
      [
      "אמת קטנה יכולה לשנות קירבה."
    ]
    ),
    action: localizedGenderNode(
      "לזכור אדם אחד שמרגיש קרוב.",
      "לזכור אדם אחד שמרגיש קרוב."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "להעיז מעט",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה להעיז מעט.",
      "לא הרבה.",
      "רק צעד קטן."
    ],
      [
      "היום אני בודק/ת איך זה להעיז מעט.",
      "לא הרבה.",
      "רק צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מפחד/ת לעשות?",
      "מה הדבר הקטן הכי בטוח?",
      "איך זה ירגיש לי אחרי?"
    ],
      [
      "מה צעד קטן שאני מפחד/ת לעשות?",
      "מה הדבר הקטן הכי בטוח?",
      "איך זה ירגיש לי אחרי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אומץ קטן הוא מספיק להיום."
    ],
      [
      "אומץ קטן הוא מספיק להיום."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן ולזכור אותו.",
      "לבחור צעד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "לבקש הכרה",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך לבקש הכרה בעדינות.",
      "בלי דרמה.",
      "רק מילה."
    ],
      [
      "היום אני בודק/ת איך לבקש הכרה בעדינות.",
      "בלי דרמה.",
      "רק מילה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי רוצה שמישהו ידע עליי?",
      "איך אפשר לומר זאת ברוך?",
      "מה הדבר הקטן שאני מוכן/ה לשתף?"
    ],
      [
      "מה הייתי רוצה שמישהו ידע עליי?",
      "איך אפשר לומר זאת ברוך?",
      "מה הדבר הקטן שאני מוכן/ה לשתף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שיתוף קטן יוצר סדק בקיר."
    ],
      [
      "שיתוף קטן יוצר סדק בקיר."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב משפט אחד שהייתי רוצה לשתף.",
      "לכתוב משפט אחד שהייתי רוצה לשתף."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "מישהו שכן מכיר אותי מעט",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מי אולי כן מכיר אותי מעט.",
      "לא רוצה הרבה.",
      "רק מעט."
    ],
      [
      "היום אני מזהה מי אולי כן מכיר אותי מעט.",
      "לא רוצה הרבה.",
      "רק מעט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מי מכיר בי משהו אמיתי?",
      "מה הוא יודע עליי?",
      "איך זה מרגיש לדעת שיש מישהו כזה?"
    ],
      [
      "מי מכיר בי משהו אמיתי?",
      "מה הוא יודע עליי?",
      "איך זה מרגיש לדעת שיש מישהו כזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מעט הכרה עדיין שווה."
    ],
      [
      "מעט הכרה עדיין שווה."
    ]
    ),
    action: localizedGenderNode(
      "לזכור את השם של האדם הזה בלב.",
      "לזכור את השם של האדם הזה בלב."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "קול פנימי שמכיר אותי",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת קול פנימי שמכיר אותי.",
      "גם אם הוא שקט.",
      "הוא שם."
    ],
      [
      "היום אני מחפש/ת קול פנימי שמכיר אותי.",
      "גם אם הוא שקט.",
      "הוא שם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני נותן/ת לה מקום."
    ],
      [
      "אני נושם/ת לאט.",
      "אני נותן/ת לה מקום."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הקול הזה יודע עליי?",
      "מה הוא אומר לי עכשיו?",
      "איך מרגיש לי להקשיב לו?"
    ],
      [
      "מה הקול הזה יודע עליי?",
      "מה הוא אומר לי עכשיו?",
      "איך מרגיש לי להקשיב לו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול פנימי שמכיר אותי הוא בית."
    ],
      [
      "קול פנימי שמכיר אותי הוא בית."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד מהקול הזה.",
      "משפט אחד מהקול הזה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן של קרבה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של קרבה.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של קרבה.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי לזוז."
    ],
      [
      "צעד קטן מספיק כדי לזוז."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי להרגשה שאני נראה/ת.",
      "כשאני נסגר/ת.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי להרגשה שאני נראה/ת.",
      "כשאני נסגר/ת.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הצורך שיכירו אותי?",
      "מה הסימן הראשון שאני נסגר/ת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על הצורך שיכירו אותי?",
      "מה הסימן הראשון שאני נסגר/ת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להרגיש לא נראה/ת ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה להרגיש לא נראה/ת ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const iHaveNoOneWhoReallyKnowsMeBlueprintHe = buildNormalizedPilotBlueprint({
  id: "i_have_no_one_who_really_knows_me_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "i_have_no_one_who_really_knows_me",
  category: "loneliness_belonging",
  journeyName: {
    he: "אין לי אף אחד שבאמת מכיר אותי",
    en: "I have no one who really knows me",
    es: "No tengo a nadie que de verdad me conozca",
  },
  days,
});

export default iHaveNoOneWhoReallyKnowsMeBlueprintHe;
